/*! bxs-vue-ui v4.0.1 */
import { A as fails, _ as _export, H as toObject, N as path } from './es.array.join.js';
import { o as objectKeys } from './index.js';

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var keys = path.Object.keys;

var keys$1 = keys;

var keys$2 = keys$1;

export { keys$2 as k };
